/**
 * Смужка «Термінал» + автовихід через бездіяльність (ТЗ2, Danyil 04.11.2026:
 * «на термінальному пристрої щоб автоматично виходив через деякий час, типу
 * 10 хв; для різних людей різний час»).
 *
 * Хвилини приходять у токені (`idle_min`: картка людини > спеціальність > 10).
 * Будь-який дотик, клавіша чи прокрутка — відлік заново. За 30 с до виходу
 * смужка червоніє й каже, що буде, — випадково вийти посеред дії не можна.
 */
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/auth";
import { toast } from "@/store/toast";

const WARN_S = 30;

export function TerminalBar() {
  const claims = useAuthStore((s) => s.claims);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();
  const on = Boolean(claims?.terminal);
  const idleS = Math.max(1, Number(claims?.idle_min) || 10) * 60;
  const last = useRef(Date.now());
  const [left, setLeft] = useState(idleS);

  useEffect(() => {
    document.body.classList.toggle("terminal-mode", on);
    if (!on) return;
    last.current = Date.now();
    const touch = () => { last.current = Date.now(); };
    const evs = ["pointerdown", "keydown", "scroll", "touchstart"] as const;
    evs.forEach((e) => window.addEventListener(e, touch, { passive: true, capture: true }));
    const t = window.setInterval(() => {
      const rest = idleS - Math.floor((Date.now() - last.current) / 1000);
      setLeft(rest);
      if (rest <= 0) {
        logout({ leaveDevice: true });
        toast.info("Термінал вийшов сам — довго не було дій. Скануй бейдж ще раз.");
        navigate("/work-terminal", { replace: true });
      }
    }, 1000);
    return () => {
      window.clearInterval(t);
      evs.forEach((e) => window.removeEventListener(e, touch, { capture: true }));
      document.body.classList.remove("terminal-mode");
    };
  }, [on, idleS, logout, navigate]);

  if (!on) return null;
  const warn = left <= WARN_S;
  const mm = Math.max(0, Math.ceil(left / 60));
  return (
    <div className={`fixed inset-x-0 top-0 z-[9998] h-12 flex items-center gap-2 px-3 text-sm font-semibold text-white shadow ${
      warn ? "bg-red-600" : "bg-indigo-700"}`} role="status">
      <span className="min-w-0 flex-1 truncate">
        {warn
          ? `Вихід через ${Math.max(0, left)} с — торкніться екрана, щоб лишитись`
          : `Термінал · ${claims?.name ?? ""} · вийде сам через ${mm} хв без дій`}
      </span>
      <button type="button"
        onClick={() => { logout({ leaveDevice: true }); navigate("/work-terminal", { replace: true }); }}
        className="h-11 min-w-[44px] px-4 rounded-full bg-white/20 hover:bg-white/30">
        Вийти
      </button>
    </div>
  );
}
